import { Color } from 'csstype';

export interface ILetter {
  key: number;
  story?: boolean;
  icon?: string;
  author: string;
  title: string;
  date: string;
  unread?: boolean;
  selected?: boolean;
  avatar?: string;
  new?: boolean;
  deleted?: boolean;
  color?: Color;
  mounted?: Boolean
}

export function generate1000Letters(): ILetter[] {
  const newLetters: ILetter[] = [];
  for (let i = 0; i < 1000; i++) {
    const sample = data[i % data.length];
    const newLetter = {
      key: Math.random() * 2100000000,
      author: sample.name,
      title: sample.phrase,
      unread: Math.random() < 0.5,
      icon: sample.name[0],
      color: `#${(((1 << 24) * Math.random()) | 0).toString(16)}`,
      date: `${Math.floor(28 * Math.random() + 1)} ${months[Math.floor(Math.random() * 12)]}`,
      new: true
    };
    newLetters.push(newLetter)
  }
  return newLetters
}

export function startSendingRandomLetters(newMailFn: () => void) {
  (function sendEmails([time1, time2]: [number, number]) {
    const minute = (x: number) => x * 60 * 1000;
    const ms = (x: number) => x;

    let delay = Math.random() * minute(10) + ms(10);
    console.log("New email will be delivered in " + delay / 60 / 1000 + " minutes");
    const time3 = new Date().getTime() + delay;
    if (time3 - time1 < minute(5)) {
      delay = minute(5);
    }
    setTimeout(() => {
      newMailFn();
      sendEmails([time2, new Date().getTime()]);
    }, delay);
  })([0, 0])
}

export function generateLetter(): ILetter {
  const sample = data[Math.floor(Math.random() * data.length)];
  return {
    key: Math.random() * 2100000000,
    author: sample.name,
    title: sample.phrase,
    unread: Math.random() < 0.5,
    icon: sample.name[0],
    color: `#${(((1 << 24) * Math.random()) | 0).toString(16)}`,
    date: `${Math.floor(28 * Math.random() + 1)} ${months[Math.floor(Math.random() * 12)]}`,
    new: true
  };
}

export const initialStateLetters = [
  {
    key: 0,
    story: true,
    icon: 'Я',
    unread: true,
    author: 'Яндекс.Паспорт',
    title: 'Доступ восстановлен',
    date: '9 мар'
  },
  {
    key: 1,
    avatar: '../images/avatar.JPG',
    author: 'Мама',
    title: 'Рецепт борща',
    date: '9 мар'
  },
  {
    key: 2,
    icon: 'И',
    unread: true,
    author: 'Иванов Иван',
    title:
      'Дипломная работа на тему "Социально педагогическая работа по развитию социальной активности старшеклассников в условиях общеобразовательного учреждения"',
    date: '7 мар'
  },
  {
    key: 3,
    author: 'Абракадабра',
    title: 'Заклинание',
    date: '5 мар'
  }
];

export const months = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек'
];

export const data: {name: string, phrase: string}[] = [
  { name: 'Лопахин', phrase: ' Пришел поезд, слава богу. Который час?' },
  { name: 'Дуняша', phrase: ' Скоро два. (Тушит свечу.) Уже светло.' },
  {
    name: 'Лопахин',
    phrase:
      ' На сколько же это опоздал поезд? Часа на два по крайней мере. (Зевает и потягивается.) Я-то хорош, какого дурака свалял! Нарочно приехал сюда, чтобы на станции встретить, и вдруг проспал… Сидя уснул. Досада… Хоть бы ты меня разбудила.'
  },
  { name: 'Дуняша', phrase: ' Я думала, что вы уехали. (Прислушивается.) Вот, кажется, уже едут.' },
  { name: 'Дуняша', phrase: ' А собаки всю ночь не спали, чуют, что хозяева едут.' },
  { name: 'Лопахин', phrase: ' Что ты, Дуняша, такая…' },
  { name: 'Дуняша', phrase: ' Руки трясутся. Я в обморок упаду.' },
  {
    name: 'Лопахин',
    phrase:
      ' Очень уж ты нежная, Дуняша. И одеваешься, как барышня, и прическа тоже. Так нельзя. Надо себя помнить.'
  },
  { name: 'Лопахин', phrase: ' И квасу мне принесешь.' },
  { name: 'Дуняша', phrase: ' Слушаю. (Уходит.)' },
  {
    name: 'Епиходов',
    phrase:
      ' Сейчас утренник, мороз в три градуса, а вишня вся в цвету. Не могу одобрить нашего климата. (Вздыхает.) Не могу. Наш климат не может способствовать в самый раз. Вот, Ермолай Алексеич, позвольте вам присовокупить, купил я себе третьего дня сапоги, а они, смею вас уверить, скрипят так, что нет никакой возможности. Чем бы смазать?'
  },
  { name: 'Лопахин', phrase: ' Отстань. Надоел.' },
  {
    name: 'Епиходов',
    phrase:
      ' Каждый день случается со мной какое-нибудь несчастье. И я не ропщу, привык и даже улыбаюсь.'
  },
  { name: 'Дуняша', phrase: ' А мне, Ермолай Алексеич, признаться, Епиходов предложение сделал.' },
  { name: 'Лопахин', phrase: ' А!' },
  {
    name: 'Дуняша',
    phrase:
      ' Не знаю уж как… Человек он смирный, а только иной раз как начнет говорить, ничего не поймешь. И хорошо, и чувствительно, только непонятно. Мне он как будто и нравится. Он меня любит безумно. Человек он несчастливый, каждый день что-нибудь. Его так и дразнят у нас: двадцать два несчастья…'
  },
  { name: 'Дуняша', phrase: ' Едут! Что ж это со мной… похолодела вся.' },
  {
    name: 'Лопахин',
    phrase: ' Едут, в самом деле. Пойдем встречать. Узнает ли она меня? Пять лет не видались.'
  },
  { name: 'Аня', phrase: ' Пройдемте здесь. Ты, мама, помнишь, какая это комната?' },
  {
    name: 'Варя',
    phrase:
      ' Как холодно, у меня руки закоченели. (Любови Андреевне.) Ваши комнаты, белая и фиолетовая, такими же и остались, мамочка.'
  },
  { name: 'Гаев', phrase: ' Поезд опоздал на два часа. Каково? Каковы порядки?' },
  { name: 'Дуняша', phrase: ' Заждались мы… (Снимает с Ани пальто, шляпу.)' },
  { name: 'Аня', phrase: ' Я не спала в дороге четыре ночи… теперь озябла очень.' },
  {
    name: 'Дуняша',
    phrase:
      ' Вы уехали в Великом посту, тогда был снег, был мороз, а теперь? Милая моя! (Смеется, целует ее.) Заждалась вас, радость моя, светик… Я скажу вам сейчас, одной минутки не могу утерпеть…'
  },
  { name: 'Дуняша', phrase: ' Конторщик Епиходов после Святой мне предложение сделал.' },
  {
    name: 'Аня',
    phrase:
      ' Ты все об одном… (Поправляя волосы.) Я растеряла все шпильки… (Она очень утомлена, даже пошатывается.)'
  },
  { name: 'Дуняша', phrase: ' Уж я не знаю, что и думать. Он меня любит, так любит!' },
  { name: 'Дуняша', phrase: ' Третьего дня Петр Сергеич приехали.' },
  {
    name: 'Дуняша',
    phrase:
      ' В бане спят, там и живут. Боюсь, говорят, стеснить. (Взглянув на свои карманные часы.) Надо бы их разбудить, да Варвара Михайловна не велела. Ты, говорит, его не буди.'
  },
  { name: 'Варя', phrase: ' Дуняша, кофе поскорей… Мамочка кофе просит.' },
  { name: 'Дуняша', phrase: ' Сию минуточку. (Уходит.)' },
  {
    name: 'Варя',
    phrase:
      ' Ну слава богу, приехали. Опять ты дома. (Ласкаясь.) Душечка моя приехала! Красавица приехала!'
  },
  { name: 'Аня', phrase: ' Натерпелась я.' },
  { name: 'Варя', phrase: ' Воображаю!' },
  {
    name: 'Аня',
    phrase:
      ' Выехала я на Страстной неделе, тогда было холодно. Шарлотта всю дорогу говорит, представляет фокусы. И зачем ты навязала мне Шарлотту…'
  },
  { name: 'Варя', phrase: ' Нельзя же тебе одной ехать, душечка. В семнадцать лет!' },
  {
    name: 'Аня',
    phrase:
      ' Приезжаем в Париж, там холодно, снег. По-французски говорю я ужасно. Мама живет на пятом этаже, прихожу к ней, у нее какие-то французы, дамы, старый патер с книжкой, и накурено, неуютно. Мне вдруг стало жаль мамы, так жаль, я обняла ее голову, сжала руками и не могу выпустить. Мама потом все ласкалась, плакала…'
  },
  {
    name: 'Аня',
    phrase:
      ' Дачу свою около Ментоны она уже продала, у нее ничего не осталось, ничего. У меня тоже не осталось ни копейки, едва доехали. И мама не понимает! Сядем на вокзале обедать, и она требует самое дорогое и на чай лакеям дает по рублю. Шарлотта тоже. Яша тоже требует себе порцию, просто ужасно. Ведь у мамы лакей Яша, мы привезли его сюда…'
  },
  { name: 'Варя', phrase: ' Видела подлеца.' },
  { name: 'Аня', phrase: ' Ну что, как? Заплатили проценты?' },
  { name: 'Варя', phrase: ' Где там.' },
  { name: 'Аня', phrase: ' Боже мой, боже мой…' },
  { name: 'Варя', phrase: ' В августе будут продавать имение…' },
  { name: 'Аня', phrase: ' Боже мой…' },
  {
    name: 'Варя',
    phrase:
      ' Я так думаю, ничего у нас не выйдет. У него дела много, ему не до меня… и внимания не обращает. Бог с ним совсем, тяжело мне его видеть… Все говорят о нашей свадьбе, все поздравляют, а на самом деле ничего нет, всё как сон… (Другим тоном.) У тебя брошка вроде как пчелка.'
  },
  { name: 'Варя', phrase: ' Душечка моя приехала! Красавица приехала!' },
  { name: 'Аня', phrase: ' Птицы поют в саду. Который теперь час?' },
  {
    name: 'Варя',
    phrase: ' Должно, третий. Тебе пора спать, душечка. (Входя в комнату к Ане.) Благолепие!'
  },
  { name: 'Дуняша', phrase: ' И не узнаешь вас, Яша. Какой вы стали за границей.' },
  { name: 'Яша', phrase: ' Гм… А вы кто?' },
  {
    name: 'Дуняша',
    phrase:
      ' Когда вы уезжали отсюда, я была этакой… (Показывает от пола.) Дуняша, Федора Козоедова дочь. Вы не помните!'
  },
  {
    name: 'Яша',
    phrase:
      ' Гм… Огурчик! (Оглядывается и обнимает ее; она вскрикивает и роняет блюдечко. Яша быстро уходит.)'
  },
  { name: 'Варя', phrase: ' Это к добру.' },
  { name: 'Варя', phrase: ' Я приказала его не будить.' },
  { name: 'Дуняша', phrase: ' Ах, боже мой… (Быстро уходит.)' },
  { name: 'Варя', phrase: ' Фирс, ты о чем?' },
  {
    name: 'Фирс',
    phrase:
      ' Чего изволите? (Радостно.) Барыня моя приехала! Дождался! Теперь хоть и помереть… (Плачет от радости.)'
  },
  {
    name: 'Гаев',
    phrase:
      ' Режу в угол! Когда-то мы с тобой, сестра, спали вот в этой самой комнате, а теперь мне уже пятьдесят один год, как это ни странно…'
  },
  { name: 'Лопахин', phrase: ' Да, время идет.' },
  { name: 'Гаев', phrase: ' Кого?' },
  { name: 'Лопахин', phrase: ' Время, говорю, идет.' },
  { name: 'Гаев', phrase: ' А здесь пачулями пахнет.' },
  { name: 'Аня', phrase: ' Я спать пойду. Спокойной ночи, мама. (Целует мать.)' },
  { name: 'Аня', phrase: ' Прощай, дядя.' },
  { name: 'Пищик', phrase: ' Дорога, небось, длинная.' },
  { name: 'Варя', phrase: ' Поглядеть, все ли вещи привезли… (Уходит.)' },
  { name: 'Фирс', phrase: ' Позавчера.' },
  { name: 'Гаев', phrase: ' Он плохо слышит.' },
  {
    name: 'Лопахин',
    phrase:
      ' Мне сейчас, в пятом часу утра, в Харьков ехать. Такая досада! Хотелось поглядеть на вас, поговорить… Вы все такая же великолепная.'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Ваш брат, вот Леонид Андреич, говорит про меня, что я хам, я кулак, но это мне решительно все равно. Пускай говорит. Хотелось бы только, чтобы вы мне верили по-прежнему, чтобы ваши удивительные, трогательные глаза глядели на меня, как прежде. Боже милосердный! Мой отец был крепостным у вашего деда и отца, но вы, собственно вы, сделали для меня когда-то так много, что я забыл все и люблю вас, как родную… больше, чем родную.'
  },
  { name: 'Гаев', phrase: ' А без тебя тут няня умерла.' },
  {
    name: 'Гаев',
    phrase:
      ' И Анастасий умер. Петрушка Косой от меня ушел и теперь в городе у пристава живет. (Вынимает из кармана коробку с леденцами, сосет.)'
  },
  { name: 'Пищик', phrase: ' Дочка моя, Дашенька… вам кланяется…' },
  {
    name: 'Лопахин',
    phrase:
      ' Мне хочется сказать вам что-нибудь очень приятное, веселое. (Взглянув на часы.) Сейчас уеду, некогда разговаривать… ну, да я в двух-трех словах. Вам уже известно, вишневый сад ваш продается за долги, на двадцать второе августа назначены торги, но вы не беспокоитесь, моя дорогая, спите себе спокойно, выход есть… Вот мой проект. Прошу внимания! Ваше имение находится только в двадцати верстах от города, возле прошла железная дорога, и если вишневый сад и землю по реке разбить на дачные участки и отдавать потом в аренду под дачи, то вы будете иметь самое малое двадцать пять тысяч в год дохода.'
  },
  { name: 'Гаев', phrase: ' Извините, какая чепуха!' },
  {
    name: 'Лопахин',
    phrase:
      ' Вы будете брать с дачников самое малое по двадцать пять рублей в год за десятину, и если теперь же объявите, то, я ручаюсь чем угодно, у вас до осени не останется ни одного свободного клочка, все разберут. Одним словом, поздравляю, вы спасены. Местоположение чудесное, река глубокая. Только, конечно, нужно поубрать, почистить, например, скажем, снести все старые постройки, вот этот дом, который уже никуда не годится, вырубить старый вишневый сад…'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Замечательного в этом саду только то, что он очень большой. Вишня родится раз в два года, да и ту девать некуда, никто не покупает.'
  },
  { name: 'Гаев', phrase: ' И в «Энциклопедическом словаре» упоминается про этот сад.' },
  {
    name: 'Фирс',
    phrase:
      ' В прежнее время, лет сорок—пятьдесят назад, вишню сушили, мочили, мариновали, варенье варили, и, бывало…'
  },
  { name: 'Гаев', phrase: ' Помолчи, Фирс.' },
  {
    name: 'Фирс',
    phrase:
      ' И бывало, сушеную вишню возами отправляли в Москву и в Харьков. Денег было! И сушеная вишня тогда была мягкая, сочная, сладкая, душистая… Способ тогда знали…'
  },
  { name: 'Фирс', phrase: ' Забыли. Никто не помнит' },
  { name: 'Пищик', phrase: ' Вы подумайте…' },
  {
    name: 'Лопахин',
    phrase:
      ' До сих пор в деревне были только господа и мужики, а теперь появились еще дачники. Все города, даже самые небольшие, окружены теперь дачами. И можно сказать, дачник лет через двадцать размножится до необычайности. Теперь он только чаи пьет на балконе, но ведь может случиться, что на своей одной десятине он займется хозяйством, и тогда ваш вишневый сад станет счастливым, богатым, роскошным…'
  },
  {
    name: 'Варя',
    phrase:
      ' Тут, мамочка, вам две телеграммы. (Выбирает ключ и со звоном отпирает старинный шкаф.) Вот они.'
  },
  {
    name: 'Гаев',
    phrase:
      ' А ты знаешь, Люба, сколько этому шкафу лет? Неделю назад я выдвинул нижний ящик, гляжу, а там выжжены цифры. Шкаф сделан ровно сто лет тому назад. Каково? А? Можно было бы юбилей отпраздновать. Предмет неодушевленный, а все-таки, как-никак, книжный шкаф.'
  },
  {
    name: 'Гаев',
    phrase:
      ' Да… Это вещь… (Ощупав шкаф.) Дорогой, многоуважаемый шкаф! Приветствую твое существование, которое вот уже больше ста лет было направлено к светлым идеалам добра и справедливости; твой молчаливый призыв к плодотворной работе не ослабевал в течение ста лет, поддерживая (сквозь слезы) в поколениях нашего рода бодрость, веру в лучшее будущее и воспитывая в нас идеалы добра и общественного самосознания.'
  },
  { name: 'Лопахин', phrase: ' Да…' },
  {
    name: 'Пищик',
    phrase:
      ' Не надо принимать медикаменты, милейшая… от них ни вреда, ни пользы… Дайте-ка сюда… многоуважаемая. (Берет пилюли, высыпает их себе на ладонь, дует на них, кладет в рот и запивает квасом.) Вот!'
  },
  { name: 'Пищик', phrase: ' Все пилюли принял.' },
  { name: 'Лопахин', phrase: ' Экая прорва.' },
  { name: 'Фирс', phrase: ' Они были у нас на Святой, полведра огурцов скушали… (Бормочет.)' },
  { name: 'Варя', phrase: ' Уж три года так бормочет. Мы привыкли.' },
  { name: 'Яша', phrase: ' Преклонный возраст.' },
  {
    name: 'Лопахин',
    phrase:
      ' Простите, Шарлотта Ивановна, я не успел еще поздороваться с вами. (Хочет поцеловать у нее руку.)'
  },
  { name: 'Лопахин', phrase: ' Не везет мне сегодня.' },
  { name: 'Шарлотта', phrase: ' Не надо. Я спать желаю. (Уходит.)' },
  {
    name: 'Лопахин',
    phrase:
      ' Через три недели увидимся. (Целует Любови Андреевне руку.) Пока прощайте. Пора. (Гаеву.) До свиданция. (Целуется с Пищиком.) До свиданция. (Подает руку Варе, потом Фирсу и Яше.) Не хочется уезжать. (Любови Андреевне.) Ежели надумаете насчет дач и решите, тогда дайте знать, я взаймы тысяч пятьдесят достану. Серьезно подумайте.'
  },
  { name: 'Лопахин', phrase: ' Ухожу, ухожу… (Уходит.)' },
  { name: 'Гаев', phrase: ' Хам. Впрочем, пардон… Варя выходит за него замуж, это Варин женишок.' },
  { name: 'Варя', phrase: ' Не говорите, дядечка, лишнего.' },
  {
    name: 'Пищик',
    phrase:
      ' Человек, надо правду говорить… достойнейший… И моя Дашенька… тоже говорит, что… разные слова говорит. (Храпит, но тотчас же просыпается.) А все-таки, многоуважаемая, одолжите мне… взаймы двести сорок рублей… завтра по закладной проценты платить…'
  },
  {
    name: 'Пищик',
    phrase:
      ' Найдутся. (Смеется.) Не теряю никогда надежды. Вот, думаю, уж все пропало, погиб, ан глядь, — железная дорога по моей земле прошла, и… мне заплатили. А там, гляди, еще что-нибудь случится не сегодня-завтра… Двести тысяч выиграет Дашенька… у нее билет есть.'
  },
  { name: 'Гаев', phrase: ' Да, и сад продадут за долги, как это ни странно…' },
  { name: 'Гаев', phrase: ' Где?' },
  { name: 'Варя', phrase: ' Господь с вами, мамочка.' },
  { name: 'Трофимов', phrase: ' Любовь Андреевна!' },
  {
    name: 'Трофимов',
    phrase: ' Петя Трофимов, бывший учитель вашего Гриши… Неужели я так изменился?'
  },
  { name: 'Варя', phrase: ' Что же делать, мамочка. Воля божья.' },
  { name: 'Трофимов', phrase: ' Меня в вагоне одна баба назвала так: облезлый барин.' },
  { name: 'Трофимов', phrase: ' Должно быть, я буду вечным студентом.' },
  { name: 'Гаев', phrase: ' А этот все свое.' },
  { name: 'Пищик', phrase: ' Двести сорок рублей… проценты по закладной платить.' },
  { name: 'Пищик', phrase: ' Отдам, милая… Сумма пустяшная…' },
  { name: 'Гаев', phrase: ' Дам я ему, держи карман.' },
  {
    name: 'Гаев',
    phrase:
      ' Сестра не отвыкла еще сорить деньгами. (Яше.) Отойди, любезный, от тебя курицей пахнет.'
  },
  { name: 'Гаев', phrase: ' Кого? (Варе.) Что он сказал?' },
  { name: 'Яша', phrase: ' Бог с ней совсем!' },
  { name: 'Варя', phrase: ' Ах бесстыдник!' },
  { name: 'Яша', phrase: ' Очень нужно. Могла бы и завтра прийти. (Уходит.)' },
  {
    name: 'Варя',
    phrase:
      ' Мамочка такая же, как была, нисколько не изменилась. Если бы ей волю, она бы все раздала.'
  },
  { name: 'Гаев', phrase: ' Да…' },
  {
    name: 'Гаев',
    phrase:
      ' Не реви. Тетка очень богата, но нас она не любит. Сестра, во-первых, вышла замуж за присяжного поверенного, не дворянина…'
  },
  { name: 'Гаев', phrase: ' Кого?' },
  { name: 'Варя', phrase: ' Что же ты не спишь, Аня?' },
  { name: 'Аня', phrase: ' Не спится. Не могу.' },
  {
    name: 'Гаев',
    phrase:
      ' Крошка моя. (Целует Ане лицо, руки.) Дитя мое… (Сквозь слезы.) Ты не племянница, ты мой ангел, ты для меня все. Верь мне, верь…'
  },
  {
    name: 'Аня',
    phrase:
      ' Я верю тебе, дядя. Тебя все любят, уважают… но, милый дядя, тебе надо молчать, только молчать. Что ты говорил только что про мою маму, про свою сестру? Для чего ты это говорил?'
  },
  {
    name: 'Гаев',
    phrase:
      ' Да, да… (Ее рукой закрывает себе лицо.) В самом деле, это ужасно! Боже мой! Боже, спаси меня! И сегодня я речь говорил перед шкафом… так глупо! И только когда кончил, понял, что глупо.'
  },
  { name: 'Варя', phrase: ' Правда, дядечка, вам надо бы молчать. Молчите себе, и все.' },
  { name: 'Аня', phrase: ' Если будешь молчать, то тебе же самому будет покойнее.' },
  {
    name: 'Гаев',
    phrase:
      ' Молчу. (Целует Ане и Варе руки.) Молчу. Только вот о деле. В четверг я был в окружном суде, ну, сошлась компания, начался разговор о том о сем, пятое-десятое, и, кажется, вот можно будет устроить заем под векселя, чтобы заплатить проценты в банк.'
  },
  { name: 'Варя', phrase: ' Если бы господь помог!' },
  {
    name: 'Гаев',
    phrase:
      ' Во вторник поеду, еще раз поговорю. (Варе.) Не реви. (Ане.) Твоя мама поговорит с Лопахиным; он, конечно, ей не откажет… А ты, как отдохнешь, поедешь в Ярославль к графине, твоей бабушке. Вот так и будем действовать с трех концов — и дело наше в шляпе. Проценты мы заплатим, я убежден… (Кладет в рот леденец.) Честью моей, чем хочешь, клянусь, имение не будет продано! (Возбужденно.) Счастьем моим клянусь! Вот тебе моя рука, назови меня тогда дрянным, бесчестным человеком, если я допущу до аукциона! Всем существом моим клянусь!'
  },
  {
    name: 'Гаев',
    phrase:
      ' Сейчас, сейчас. Ты уходи, Фирс. Я уж, так и быть, сам разденусь. Ну, детки, бай-бай… Подробности завтра, а теперь идите спать. (Целует Аню и Варю.) Я человек восьмидесятых годов… Не хвалят это время, но все же могу сказать, за убеждения мне доставалось немало в жизни. Недаром меня мужик любит. Мужика надо знать! Надо знать, с какой…'
  },
  { name: 'Аня', phrase: ' Опять ты, дядя!' },
  { name: 'Варя', phrase: ' Вы, дядечка, молчите.' },
  {
    name: 'Гаев',
    phrase:
      ' Иду, иду… Ложитесь. От двух бортов в середину! Кладу чистого… (Уходит, за ним семенит Фирс.)'
  },
  {
    name: 'Аня',
    phrase:
      ' Я теперь покойна. В Ярославль ехать не хочется, я не люблю бабушку, но все же я покойна. Спасибо дяде. (Садится.)'
  },
  {
    name: 'Варя',
    phrase:
      ' Надо спать. Пойду. А тут без тебя было неудовольствие. В старой людской, как тебе известно, живут одни старые слуги: Ефимьюшка, Поля, Евстигней, ну и Карп. Стали они пускать к себе ночевать каких-то проходимцев — я промолчала. Только вот, слышу, распустили слух, будто я велела кормить их одним только горохом. От скупости, видишь ли… И это все Евстигней… Хорошо, думаю. Коли так, думаю, то погоди же. Зову я Евстигнея… (Зевает.) Приходит… Как же ты, говорю, Евстигней… дурак ты этакой… (Поглядев на Аню.) Анечка!..'
  },
  { name: 'Варя', phrase: ' Пойдем, родная, пойдем… (Уходит в комнату Ани.)' },
  {
    name: 'Поле',
    phrase:
      ' Старая, покривившаяся, давно заброшенная часовенка, возле нее колодец, большие камни, когда-то бывшие, по-видимому, могильными плитами, и старая скамья. Видна дорога в усадьбу Гаева. В стороне, возвышаясь, темнеют тополи: там начинается вишневый сад. Вдали ряд телеграфных столбов, и далеко-далеко на горизонте неясно обозначается большой город, который бывает виден только в очень хорошую, ясную погоду. Скоро сядет солнце. Шарлотта, Яша и Дуняша сидят на скамье; Епиходов стоит возле и играет на гитаре; все сидят задумавшись. Шарлотта в старой фуражке: она сняла с плеч ружье и поправляет пряжку на ремне.'
  },
  { name: 'Дуняша', phrase: ' Это гитара, а не мандолина. (Глядится в зеркальце и пудрится.)' },
  {
    name: 'Епиходов',
    phrase:
      ' Для безумца, который влюблен, это мандолина… (Напевает.) «Было бы сердце согрето жаром взаимной любви…»'
  },
  { name: 'Шарлотта', phrase: ' Ужасно поют эти люди… фуй! Как шакалы.' },
  {
    name: 'Яша',
    phrase: ' Да, конечно. Не могу с вами не согласиться. (Зевает, потом закуривает сигару.)'
  },
  { name: 'Епиходов', phrase: ' Понятное дело. За границей все давно уж в полной комплекции.' },
  { name: 'Яша', phrase: ' Само собой.' },
  {
    name: 'Епиходов',
    phrase:
      ' Я развитой человек, читаю разные замечательные книги, но никак не могу понять направления, чего мне собственно хочется, жить мне или застрелиться, собственно говоря, но тем не менее я всегда ношу при себе револьвер. Вот он… (Показывает револьвер.)'
  },
  {
    name: 'Шарлотта',
    phrase:
      ' Кончила. Теперь пойду. (Надевает ружье.) Ты, Епиходов, очень умный человек и очень страшный; тебя должны безумно любить женщины. Бррр! (Идет.) Эти умники все такие глупые, не с кем мне поговорить… Все одна, одна, никого у меня нет и… и кто я, зачем я, неизвестно… (Уходит не спеша.)'
  },
  {
    name: 'Епиходов',
    phrase:
      ' Собственно говоря, не касаясь других предметов, я должен выразиться о себе, между прочим, что судьба относится ко мне без сожаления, как буря к небольшому кораблю. Если, допустим, я ошибаюсь, тогда зачем же сегодня утром я просыпаюсь, к примеру сказать, гляжу, а у меня на груди страшной величины паук… Вот такой. (Показывает обеими руками.) И тоже квасу возьмешь, чтобы напиться, а там, глядишь, что-нибудь в высшей степени неприличное, вроде таракана.'
  },
  { name: 'Дуняша', phrase: ' Говорите.' },
  { name: 'Епиходов', phrase: ' Мне бы желательно с вами наедине… (Вздыхает.)' },
  {
    name: 'Епиходов',
    phrase:
      ' Хорошо-с… принесу-с… Теперь я знаю, что мне делать с моим револьвером… (Берет гитару и уходит, наигрывая.)'
  },
  { name: 'Яша', phrase: ' Двадцать два несчастья! Глупый человек, между нами говоря. (Зевает.)' },
  { name: 'Дуняша', phrase: ' Не дай бог, застрелится.' },
  {
    name: 'Дуняша',
    phrase: ' Я страстно полюбила вас, вы образованный, можете обо всем рассуждать.'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Надо окончательно решить — время не ждет. Вопрос ведь совсем пустой. Согласны вы отдать землю под дачи или нет? Ответьте одно слово: да или нет? Только одно слово!'
  },
  {
    name: 'Гаев',
    phrase:
      ' Вот железную дорогу построили, и стало удобно. (Садится.) Съездили в город и позавтракали… желтого в середину! Мне бы сначала пойти в дом, сыграть одну партию…'
  },
  { name: 'Лопахин', phrase: ' Только одно слово! (Умоляюще.) Дайте же мне ответ!' },
  { name: 'Яша', phrase: ' Позвольте, я сейчас подберу. (Собирает монеты.)' },
  { name: 'Лопахин', phrase: ' Да.' },
  {
    name: 'Лопахин',
    phrase: ' Ваше имение собирается купить богач Дериганов. На торги, говорят, приедет сам лично.'
  },
  { name: 'Лопахин', phrase: ' В городе говорят.' },
  {
    name: 'Гаев',
    phrase: ' Ярославская тетушка обещала прислать, а когда и сколько пришлет, неизвестно…'
  },
  { name: 'Лопахин', phrase: ' Сколько она пришлет? Тысяч сто? Двести?' },
  {
    name: 'Лопахин',
    phrase:
      ' Простите, таких легкомысленных людей, как вы, господа, таких неделовых, странных, я еще не встречал. Вам говорят русским языком, имение ваше продается, а вы точно не понимаете.'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Я вас каждый день учу. Каждый день я говорю все одно и то же. И вишневый сад и землю необходимо отдать в аренду под дачи, сделать это теперь же, поскорее — аукцион на носу! Поймите! Раз окончательно решите, чтобы были дачи, так денег вам дадут сколько угодно, и вы тогда спасены.'
  },
  { name: 'Гаев', phrase: ' Совершенно с тобой согласен.' },
  {
    name: 'Лопахин',
    phrase:
      ' Я или зарыдаю, или закричу, или в обморок упаду. Не могу! Вы меня замучили! (Гаеву.) Баба вы!'
  },
  { name: 'Гаев', phrase: ' Кого?' },
  { name: 'Лопахин', phrase: ' Баба! (Хочет уйти.)' },
  { name: 'Лопахин', phrase: ' О чем тут думать!' },
  { name: 'Лопахин', phrase: ' Какие у вас грехи…' },
  {
    name: 'Гаев',
    phrase: ' Это наш знаменитый еврейский оркестр. Помнишь, четыре скрипки, флейта и контрабас.'
  },
  { name: 'Лопахин', phrase: ' Это правда. Надо прямо говорить, жизнь у нас дурацкая…' },
  { name: 'Лопахин', phrase: ' Да… Это правда.' },
  { name: 'Лопахин', phrase: ' Да.' },
  { name: 'Лопахин', phrase: ' Что же? Я не прочь… Она хорошая девушка.' },
  { name: 'Гаев', phrase: ' Мне предлагают место в банке. Шесть тысяч в год… Слыхала?' },
  { name: 'Фирс', phrase: ' Нечего там… Утром уехали, не сказавшись. (Оглядывает его.)' },
  { name: 'Фирс', phrase: ' Чего изволите?' },
  { name: 'Лопахин', phrase: ' Говорят, ты постарел очень!' },
  {
    name: 'Фирс',
    phrase:
      ' Живу давно. Меня женить собирались, а вашего папаши еще на свете не было… (Смеется.) А воля вышла, я уже старшим камердинером был. Тогда я не согласился на волю, остался при господах…'
  },
  { name: 'Лопахин', phrase: ' Прежде очень хорошо было. По крайней мере драли.' },
  {
    name: 'Гаев',
    phrase:
      ' Помолчи, Фирс. Завтра мне нужно в город. Обещали познакомить с одним генералом, который может дать под вексель.'
  },
  {
    name: 'Лопахин',
    phrase: ' Ничего у вас не выйдет. И не заплатите вы процентов, будьте покойны.'
  },
  { name: 'Гаев', phrase: ' А вот и наши идут.' },
  { name: 'Аня', phrase: ' Мама сидит.' },
  { name: 'Лопахин', phrase: ' Наш вечный студент все с барышнями ходит.' },
  { name: 'Трофимов', phrase: ' Не ваше дело.' },
  { name: 'Лопахин', phrase: ' Ему пятьдесят лет скоро, а он все еще студент.' },
  { name: 'Трофимов', phrase: ' Оставьте ваши дурацкие шутки.' },
  { name: 'Лопахин', phrase: ' Что же ты, чудак, сердишься?' },
  { name: 'Трофимов', phrase: ' А ты не приставай.' },
  {
    name: 'Трофимов',
    phrase:
      ' Я, Ермолай Алексеич, так понимаю: вы богатый человек, будете скоро миллионером. Вот как в смысле обмена веществ нужен хищный зверь, который съедает все, что попадается ему на пути, так и ты нужен.'
  },
  { name: 'Варя', phrase: ' Вы, Петя, расскажите лучше о планетах.' },
  { name: 'Трофимов', phrase: ' О чем это?' },
  { name: 'Гаев', phrase: ' О гордом человеке.' },
  {
    name: 'Трофимов',
    phrase:
      ' Мы вчера говорили долго, но ни к чему не пришли. В гордом человеке, в вашем смысле, есть что-то мистическое. Быть может, вы и правы по-своему, но если рассуждать попросту, без затей, то какая там гордость, есть ли в ней смысл, если человек физиологически устроен неважно, если в своем громадном большинстве он груб, неумен, глубоко несчастлив. Надо перестать восхищаться собой. Надо бы только работать.'
  },
  { name: 'Гаев', phrase: ' Все равно умрешь.' },
  {
    name: 'Трофимов',
    phrase:
      ' Кто знает? И что значит — умрешь? Быть может, у человека сто чувств и со смертью погибают только пять, известных нам, а остальные девяносто пять остаются живы.'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Человечество идет вперед, совершенствуя свои силы. Все, что недосягаемо для него теперь, когда-нибудь станет близким, понятным, только вот надо работать, помогать всеми силами тем, кто ищет истину. У нас, в России, работают пока очень немногие. Громадное большинство той интеллигенции, какую я знаю, ничего не ищет, ничего не делает и к труду пока не способно. Называют себя интеллигенцией, а прислуге говорят «ты», с мужиками обращаются, как с животными, учатся плохо, серьезно ничего не читают, ровно ничего не делают, о науках только говорят, в искусстве понимают мало. Все серьезны, у всех строгие лица, все говорят только о важном, философствуют, а между тем у всех на глазах рабочие едят отвратительно, спят без подушек, по тридцати, по сорока в одной комнате, везде клопы, смрад, сырость, нравственная нечистота… И, очевидно, все хорошие разговоры у нас для того только, чтобы отвести глаза себе и другим. Укажите мне, где у нас ясли, о которых говорят так много и часто, где читальни? О них только в романах пишут, на деле же их нет совсем. Есть только грязь, пошлость, азиатчина… Я боюсь и не люблю очень серьезных физиономий, боюсь серьезных разговоров. Лучше помолчим!'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Знаете, я встаю в пятом часу утра, работаю с утра до вечера, ну, у меня постоянно деньги свои и чужие, и я вижу, какие кругом люди. Надо только начать делать что-нибудь, чтобы понять, как мало честных, порядочных людей. Иной раз, когда не спится, я думаю: господи, ты дал нам громадные леса, необъятные поля, глубочайшие горизонты, и, живя тут, мы сами должны бы по-настоящему быть великанами…'
  },
  { name: 'Гаев', phrase: ' Солнце село, господа.' },
  { name: 'Трофимов', phrase: ' Да.' },
  { name: 'Аня', phrase: ' Дядя, ты опять!' },
  { name: 'Трофимов', phrase: ' Вы лучше желтого в середину дуплетом.' },
  { name: 'Гаев', phrase: ' Я молчу, молчу.' },
  {
    name: 'Лопахин',
    phrase: ' Не знаю. Где-нибудь далеко в шахтах сорвалась бадья. Но где-нибудь очень далеко.'
  },
  { name: 'Гаев', phrase: ' А может быть, птица какая-нибудь… вроде цапли.' },
  { name: 'Трофимов', phrase: ' Или филин…' },
  {
    name: 'Фирс',
    phrase: ' Перед несчастьем то же было: и сова кричала, и самовар гудел бесперечь.'
  },
  { name: 'Гаев', phrase: ' Перед каким несчастьем?' },
  { name: 'Фирс', phrase: ' Перед волей.' },
  { name: 'Аня', phrase: ' Это так, мама. Ничего.' },
  { name: 'Трофимов', phrase: ' Кто-то идет.' },
  { name: 'Прохожий', phrase: ' Позвольте вас спросить, могу ли я пройти здесь прямо на станцию?' },
  { name: 'Гаев', phrase: ' Можете. Идите по этой дороге.' },
  {
    name: 'Прохожий',
    phrase:
      ' Чувствительно вам благодарен. (Кашлянув.) Погода превосходная… (Декламирует.) Брат мой, страдающий брат… выдь на Волгу, чей стон… (Варе.) Мадемуазель, позвольте голодному россиянину копеек тридцать…'
  },
  { name: 'Прохожий', phrase: ' Чувствительно вам благодарен! (Уходит.)' },
  { name: 'Лопахин', phrase: ' Слушаю.' },
  { name: 'Лопахин', phrase: ' Охмелия, иди в монастырь…' },
  { name: 'Гаев', phrase: ' А у меня дрожат руки: давно не играл на бильярде.' },
  { name: 'Лопахин', phrase: ' Охмелия, о нимфа, помяни меня в твоих молитвах!' },
  { name: 'Варя', phrase: ' Напугал он меня. Сердце так и стучит.' },
  {
    name: 'Лопахин',
    phrase:
      ' Напоминаю вам, господа: двадцать второго августа будет продаваться вишневый сад. Думайте об этом!.. Думайте!..'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Варя боится, а вдруг мы полюбим друг друга, и целые дни не отходит от нас. Она своей узкой головой не может понять, что мы выше любви. Обойти то мелкое и призрачное, что мешает быть свободным и счастливым, — вот цель и смысл нашей жизни. Вперед! Мы идем неудержимо к яркой звезде, которая горит там вдали! Вперед! Не отставай, друзья!'
  },
  { name: 'Трофимов', phrase: ' Да, погода удивительная.' },
  {
    name: 'Аня',
    phrase:
      ' Что вы со мной сделали, Петя, отчего я уже не люблю вишневого сада, как прежде. Я любила его так нежно, мне казалось, на земле нет лучше места, как наш сад.'
  },
  {
    name: 'Трофимов',
    phrase: ' Вся Россия наш сад. Земля велика и прекрасна, есть на ней много чудесных мест.'
  },
  {
    name: 'Аня',
    phrase: ' Дом, в котором мы живем, давно уже не наш дом, и я уйду, даю вам слово.'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Если у вас есть ключи от хозяйства, то бросьте их в колодец и уходите. Будьте свободны, как ветер.'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Верьте мне, Аня, верьте! Мне еще нет тридцати, я молод, я еще студент, но я уже столько вынес! Как зима, так я голоден, болен, встревожен, беден, как нищий, и — куда только судьба не гоняла меня, где я только не был! И все же душа моя всегда, во всякую минуту, и днем и ночью, была полна неизъяснимых предчувствий. Я предчувствую счастье, Аня, я уже вижу его…'
  },
  { name: 'Трофимов', phrase: ' Да, восходит луна.' },
  { name: 'Аня', phrase: ' Что ж? Пойдемте к реке. Там хорошо.' },
  { name: 'Трофимов', phrase: ' Пойдемте.' },
  {
    name: 'Пищик',
    phrase:
      ' Я полнокровный, со мной уже два раза удар был, танцевать трудно, но, как говорится, попал в стаю, лай не лай, а хвостом виляй. Здоровье-то у меня лошадиное. Мой покойный родитель, шутник, царство небесное, насчет нашего происхождения говорил так, будто древний род наш Симеоновых-Пищиков происходит будто бы от той самой лошади, которую Калигула посадил в сенате… (Садится.) Но вот беда: денег нет! Голодная собака верует только в мясо… (Храпит и тотчас же просыпается.) Так и я… могу только про деньги…'
  },
  { name: 'Трофимов', phrase: ' А у вас в фигуре в самом деле есть что-то лошадиное.' },
  { name: 'Пищик', phrase: ' Что ж… лошадь хороший зверь… лошадь продать можно…' },
  { name: 'Трофимов', phrase: ' Да, я облезлый барин и горжусь этим!' },
  {
    name: 'Пищик',
    phrase:
      ' Ницше… философ… величайший, знаменитейший… громадного ума человек, говорит в своих сочинениях, будто фальшивые бумажки делать можно.'
  },
  { name: 'Трофимов', phrase: ' А вы читали Ницше?' },
  {
    name: 'Пищик',
    phrase:
      ' Ну… Мне Дашенька говорила. А я теперь в таком положении, что хоть фальшивые бумажки делай… Послезавтра триста десять рублей платить… Сто тридцать уже достал… (Ощупывает карманы, встревоженно.) Деньги пропали! Потерял деньги! (Сквозь слезы.) Где деньги? (Радостно). Вот они, за подкладкой… Даже в пот ударило…'
  },
  { name: 'Трофимов', phrase: ' Торги не состоялись, по всей вероятности.' },
  { name: 'Пищик', phrase: ' Задумал.' },
  {
    name: 'Шарлотта',
    phrase:
      ' Тасуйте теперь колоду. Очень хорошо. Дайте сюда, о мой милый господин Пищик. Ein, zwei, drei![2 - Раз, два, три! (нем.).] Теперь поищите, она у вас в боковом кармане…'
  },
  { name: 'Трофимов', phrase: ' Что ж? Ну, дама пик.' },
  { name: 'Шарлотта', phrase: ' Есть! (Пищику.) Ну? Какая карта сверху?' },
  { name: 'Пищик', phrase: ' Туз червовый.' },
  {
    name: 'Шарлотта',
    phrase: ' Есть!.. (Бьет по ладони, колода карт исчезает.) А какая сегодня хорошая погода!'
  },
  {
    name: 'Шарлотта',
    phrase:
      ' Влюблен? (Пожав плечами.) Разве вы можете любить? Guter Mensch, aber schlechter Musikant.[3 - Хороший человек, но плохой музыкант (нем.).]'
  },
  {
    name: 'Шарлотта',
    phrase:
      ' Прошу внимания, еще один фокус. (Берет со стула плед.) Вот очень хороший плед, я желаю продавать… (Встряхивает.) Не желает ли кто покупать?'
  },
  { name: 'Шарлотта', phrase: ' Ein, zwei, drei! (Быстро поднимает опущенный плед.)' },
  { name: 'Шарлотта', phrase: ' Теперь еще! Ein, zwei, drei.' },
  {
    name: 'Шарлотта',
    phrase: ' Конец! (Бросает плед на Пищика, делает реверанс и убегает в залу.)'
  },
  {
    name: 'Варя',
    phrase:
      ' Бабушка прислала ему доверенность, чтобы он купил на ее имя с переводом долга. Это она для Ани. И я уверена, бог поможет, дядечка купит.'
  },
  {
    name: 'Варя',
    phrase:
      ' Я смотрю на это дело серьезно, мамочка, надо прямо говорить. Он хороший человек, мне нравится.'
  },
  {
    name: 'Варя',
    phrase:
      ' Мамочка, не могу же я сама делать ему предложение. Вот уже два года все мне говорят про него, все говорят, а он или молчит, или шутит. Я понимаю. Он богатеет, занят делом, ему не до меня. Если бы были деньги, хоть немного, хоть бы сто рублей, бросила бы я все, ушла бы подальше. В монастырь бы ушла.'
  },
  { name: 'Трофимов', phrase: ' Благолепие!' },
  {
    name: 'Варя',
    phrase:
      ' Зачем же Епиходов здесь? Кто ему позволил на бильярде играть? Не понимаю этих людей… (Уходит.)'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Уж очень она усердная, не в свое дело суется. Все лето не давала покоя ни мне, ни Ане, боялась, как бы у нас романа не вышло. Какое ей дело? И к тому же я вида не подавал, я так далек от пошлости. Мы выше любви!'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Продано ли сегодня имение или не продано — не все ли равно? С ним давно уже покончено, нет поворота назад, заросла дорожка. Успокойтесь, дорогая. Не надо обманывать себя, надо хоть раз в жизни взглянуть правде прямо в глаза.'
  },
  { name: 'Трофимов', phrase: ' Вы знаете, я сочувствую всей душой.' },
  {
    name: 'Трофимов',
    phrase: ' Ведь он негодяй, только вы одна не знаете этого! Он мелкий негодяй, ничтожество…'
  },
  { name: 'Трофимов', phrase: ' Пусть!' },
  { name: 'Яша', phrase: ' Что, дедушка?' },
  {
    name: 'Фирс',
    phrase:
      ' Нездоровится. Прежде у нас на балах танцевали генералы, бароны, адмиралы, а теперь посылаем за почтовым чиновником и начальником станции, да и те не в охотку идут. Что-то ослабел я. Барин покойный, дедушка, всех сургучом пользовал, от всех болезней. Я сургуч принимаю каждый день уже лет двадцать, а то и больше; может, я от него и жив.'
  },
  { name: 'Яша', phrase: ' Надоел ты, дед. (Зевает.) Хоть бы ты поскорее подох.' },
  { name: 'Фирс', phrase: ' Эх ты… недотёпа! (Бормочет.)' },
  { name: 'Аня', phrase: ' Не сказал, кому. Ушел. (Танцует с Трофимовым, оба уходят в зал.)' },
  { name: 'Яша', phrase: ' Это там какой-то старик болтал. Чужой.' },
  {
    name: 'Фирс',
    phrase:
      ' А Леонида Андреича еще нет, не приехал. Пальто на нем легкое, демисезон, того гляди простудится. Эх, молодо-зелено.'
  },
  { name: 'Яша', phrase: ' Да он давно ушел, старик-то. (Смеется.)' },
  { name: 'Яша', phrase: ' Очень уж Епиходов смешной. Пустой человек. Двадцать два несчастья.' },
  { name: 'Фирс', phrase: ' Куда прикажете, туда и пойду.' },
  {
    name: 'Фирс',
    phrase:
      ' Да… (С усмешкой.) Я уйду спать, а без меня тут кто подаст, кто распорядится? Один на весь дом.'
  },
  {
    name: 'Пищик',
    phrase:
      ' Позвольте просить вас… на вальсишку, прекраснейшая… (Любовь Андреевна идет с ним.) Очаровательная, все-таки сто восемьдесят рубликов я возьму у вас… Возьму… (Танцует.) Сто восемьдесят рубликов…'
  },
  { name: 'Фирс', phrase: ' Что же он тебе сказал?' },
  { name: 'Дуняша', phrase: ' Вы, говорит, как цветок.' },
  { name: 'Дуняша', phrase: ' Как цветок… Я такая деликатная девушка, ужасно люблю нежные слова.' },
  { name: 'Фирс', phrase: ' Закрутишься ты.' },
  {
    name: 'Епиходов',
    phrase:
      ' Вы, Авдотья Федоровна, не желаете меня видеть… как будто я какое насекомое. (Вздыхает.) Эх, жизнь!'
  },
  { name: 'Дуняша', phrase: ' Что вам угодно?' },
  {
    name: 'Епиходов',
    phrase:
      ' Несомненно, может, вы и правы. (Вздыхает.) Но, конечно, если взглянуть с точки зрения, то вы, позволю себе так выразиться, извините за откровенность, совершенно привели меня в состояние духа. Я знаю свою фортуну, каждый день со мной случается какое-нибудь несчастье, и к этому я давно уже привык, так что с улыбкой гляжу на свою судьбу. Вы дали мне слово, и хотя я…'
  },
  {
    name: 'Дуняша',
    phrase:
      ' Прошу вас, после поговорим, а теперь оставьте меня в покое. Теперь я мечтаю. (Играет веером.)'
  },
  {
    name: 'Епиходов',
    phrase:
      ' У меня несчастье каждый день, и я, позволю себе так выразиться, только улыбаюсь, даже смеюсь.'
  },
  {
    name: 'Варя',
    phrase:
      ' Ты все еще не ушел, Семен? Какой же ты, право, неуважительный человек. (Дуняше.) Ступай отсюда, Дуняша. (Епиходову.) То на бильярде играешь и кий сломал, то по гостиной расхаживаешь, как гость.'
  },
  { name: 'Епиходов', phrase: ' С меня взыскивать, позвольте вам выразиться, вы не можете.' },
  {
    name: 'Варя',
    phrase:
      ' Я не взыскиваю с тебя, а говорю. Только и знаешь, что ходишь с места на место, а делом не занимаешься. Конторщика держим, а неизвестно — для чего.'
  },
  {
    name: 'Варя',
    phrase:
      ' Ты смеешь мне говорить это! (Вспылив.) Ты смеешь? Значит, я ничего не понимаю? Убирайся же вон отсюда! Сию минуту!'
  },
  { name: 'Лопахин', phrase: ' Покорнейше благодарю.' },
  { name: 'Лопахин', phrase: ' Ничего-с. Покорно благодарю за приятное угощение.' },
  {
    name: 'Варя',
    phrase:
      ' Не стоит благодарности. (Отходит, потом оглядывается и спрашивает мягко.) Я вас не ушибла?'
  },
  { name: 'Лопахин', phrase: ' Нет, ничего. Шишка, однако, вскочит огромадная.' },
  {
    name: 'Пищик',
    phrase:
      ' Видом видать, слыхом слыхать… (Целуется с Лопахиным.) Коньячком от тебя попахивает, милый мой, душа моя. А мы тут тоже веселимся.'
  },
  { name: 'Лопахин', phrase: ' Леонид Андреич со мной приехал, он идет…' },
  { name: 'Пищик', phrase: ' Что на торгах? Рассказывай же!' },
  { name: 'Лопахин', phrase: ' Продан.' },
  { name: 'Лопахин', phrase: ' Я купил.' },
  {
    name: 'Лопахин',
    phrase:
      ' Что ж такое? Музыка, играй отчетливо! Пускай всё, как я желаю! (С иронией.) Идет новый помещик, владелец вишневого сада! (Толкнул нечаянно столик, едва не опрокинул канделябры.) За все могу заплатить! (Уходит с Пищиком.)'
  },
  {
    name: 'Аня',
    phrase:
      ' Мама!.. Мама, ты плачешь? Милая, добрая, хорошая моя мама, моя прекрасная, я люблю тебя… я благословляю тебя. Вишневый сад продан, его уже нет, это правда, правда, но не плачь, мама, у тебя осталась жизнь впереди, осталась твоя хорошая, чистая душа… Пойдем со мной, пойдем, милая, отсюда, пойдем!.. Мы насадим новый сад, роскошнее этого, ты увидишь его, поймешь, и радость, тихая, глубокая радость опустится на твою душу, как солнце в вечерний час, и ты улыбнешься, мама! Пойдем, милая! Пойдем!..'
  },
  {
    name: 'Яша',
    phrase:
      ' Простой народ прощаться пришел. Я такого мнения, Ермолай Алексеич: народ добрый, но мало понимает.'
  },
  { name: 'Гаев', phrase: ' Ты отдала им свой кошелек, Люба. Так нельзя! Так нельзя!' },
  {
    name: 'Яша',
    phrase:
      ' С отъезжающими! Счастливо оставаться! (Пьет.) Это шампанское не настоящее, могу вас уверить.'
  },
  { name: 'Лопахин', phrase: ' Восемь рублей бутылка.' },
  { name: 'Яша', phrase: ' Не топили сегодня, все равно уезжаем. (Смеется.)' },
  { name: 'Лопахин', phrase: ' Что ты?' },
  { name: 'Яша', phrase: ' От удовольствия.' },
  {
    name: 'Лопахин',
    phrase:
      ' На дворе октябрь, а солнечно и тихо, как летом. Строиться хорошо. (Поглядев на часы в дверь.) Господа, имейте в виду, до поезда осталось всего сорок шесть минут! Значит, через двадцать минут на станцию ехать. Поторапливайтесь.'
  },
  {
    name: 'Трофимов',
    phrase:
      ' Мне кажется, ехать уже пора. Лошади поданы. Черт его знает, где мои калоши. Пропали. (В дверь.) Аня, нет моих калош! Не нашел!'
  },
  {
    name: 'Лопахин',
    phrase:
      ' А мне в Харьков надо. Поеду с вами в одном поезде. В Харькове проживу всю зиму. Я все болтался с вами, замучился без дела. Не могу без работы, не знаю, что вот делать с руками; болтаются как-то странно, точно чужие.'
  },
  { name: 'Трофимов', phrase: ' Сейчас уедем, и вы опять приметесь за свой полезный труд.' },
  { name: 'Лопахин', phrase: ' Выпей-ка стаканчик.' },
  { name: 'Трофимов', phrase: ' Не стану.' },
  { name: 'Лопахин', phrase: ' Значит, в Москву теперь?' },
  { name: 'Трофимов', phrase: ' Да, провожу их в город, а завтра в Москву.' },
  {
    name: 'Лопахин',
    phrase: ' Да… Что ж, профессора не читают лекций, небось всё ждут, когда приедешь!'
  },
  { name: 'Трофимов', phrase: ' Не твое дело.' },
  { name: 'Лопахин', phrase: ' Сколько лет, как ты в университете учишься?' },
  {
    name: 'Трофимов',
    phrase:
      ' Придумай что-нибудь поновее. Это старо и плоско. (Ищет калоши.) Знаешь, мы, пожалуй, не увидимся больше, так вот позволь мне дать тебе на прощанье один совет: не размахивай руками! Отвыкни от этой привычки — размахивать. И тоже вот строить дачи, рассчитывать, что из дачников со временем выйдут отдельные хозяева, рассчитывать так — это тоже значит размахивать… Как-никак, все-таки я тебя люблю. У тебя тонкие, нежные пальцы, как у артиста, у тебя тонкая, нежная душа…'
  },
  { name: 'Трофимов', phrase: ' Для чего мне? Не нужно.' },
  { name: 'Лопахин', phrase: ' Ведь у вас нет!' },
  {
    name: 'Трофимов',
    phrase:
      ' Есть. Благодарю вас. Я за перевод получил. Вот они тут, в кармане. (Тревожно.) А калош моих нет!'
  },
  { name: 'Трофимов', phrase: ' Что же вы сердитесь, Варя? Гм… Да это не мои калоши!' },
  {
    name: 'Лопахин',
    phrase:
      ' Я весной посеял маку тысячу десятин, и теперь заработал сорок тысяч чистого. А когда мой мак цвел, что это была за картина! Так вот я, говорю, заработал сорок тысяч и, значит, предлагаю тебе взаймы, потому что могу. Зачем же нос драть? Я мужик… попросту.'
  },
  {
    name: 'Трофимов',
    phrase: ' Твой отец был мужик, мой — аптекарь, и из этого не следует решительно ничего.'
  },
  { name: 'Лопахин', phrase: ' Дойдешь?' },
  { name: 'Трофимов', phrase: ' Дойду.' },
  {
    name: 'Лопахин',
    phrase:
      ' Ну, прощай, голубчик. Пора ехать. Мы друг перед другом нос дерем, а жизнь знай себе проходит. Когда я работаю подолгу, без устали, тогда мысли полегче, и кажется, будто мне тоже известно, для чего я существую. А сколько, брат, в России людей, которые существуют неизвестно для чего. Ну, все равно, циркуляция дела не в этом. Леонид Андреич, говорят, принял место, будет в банке, шесть тысяч в год… Только ведь не усидит, ленив очень…'
  },
  { name: 'Трофимов', phrase: ' В самом деле, неужели не хватает такта… (Уходит через переднюю.)' },
  { name: 'Лопахин', phrase: ' Сейчас, сейчас… Экие, право. (Уходит за ним.)' },
  { name: 'Аня', phrase: ' Фирса отправили в больницу?' },
  { name: 'Яша', phrase: ' Я утром говорил. Отправили, надо думать.' },
  {
    name: 'Епиходов',
    phrase:
      ' Долголетний Фирс, по моему окончательному мнению, в починку не годится, ему надо к праотцам. А я могу ему только завидовать. (Положил чемодан на картонку со шляпой и раздавил.) Ну, вот, конечно. Так и знал. (Уходит.)'
  },
  { name: 'Аня', phrase: ' Отвезли.' },
  { name: 'Варя', phrase: ' Отчего же письмо не взяли к доктору?' },
  { name: 'Аня', phrase: ' Так надо послать вдогонку… (Уходит.)' },
  {
    name: 'Дуняша',
    phrase:
      ' Хоть бы взглянули разочек, Яша. Вы уезжаете… меня покидаете… (Плачет и бросается ему на шею.)'
  },
  {
    name: 'Яша',
    phrase:
      ' Что ж плакать? (Пьет шампанское.) Через шесть дней я опять в Париже. Завтра сядем в курьерский поезд и закатим, только нас и видели. Даже как-то не верится. Вив ла Франс!..[4 - Да здравствует Франция! (фр. Vive la France!)] Здесь не по мне, не могу жить… ничего не поделаешь. Насмотрелся на невежество — будет с меня. (Пьет шампанское.) Что ж плакать? Ведите себя прилично, тогда не будете плакать.'
  },
  { name: 'Яша', phrase: ' Идут сюда. (Хлопочет около чемоданов, тихо напевает.)' },
  {
    name: 'Гаев',
    phrase: ' Ехать бы нам. Уже немного осталось. (Глядя на Яшу.) От кого это селедкой пахнет?'
  },
  { name: 'Аня', phrase: ' Очень! Начинается новая жизнь, мама!' },
  {
    name: 'Аня',
    phrase:
      ' Ты, мама, вернешься скоро, скоро… не правда ли? Я подготовлюсь, выдержу экзамен в гимназии и потом буду работать, тебе помогать. Мы, мама, будем вместе читать разные книги… Не правда ли? (Целует матери руки.) Мы будем читать в осенние вечера, прочтем много книг, и перед нами откроется новый, чудесный мир… (Мечтает.) Мама, приезжай…'
  },
  { name: 'Гаев', phrase: ' Счастливая Шарлотта: поет!' },
  { name: 'Лопахин', phrase: ' Найдем, Шарлотта Ивановна, не беспокойтесь.' },
  { name: 'Гаев', phrase: ' Все нас бросают, Варя уходит… мы стали вдруг не нужны.' },
  { name: 'Шарлотта', phrase: ' В городе мне жить негде. Надо уходить… (Напевает.) Все равно…' },
  { name: 'Лопахин', phrase: ' Чудо природы!..' },
  { name: 'Гаев', phrase: ' За деньгами небось? Слуга покорный, ухожу от греха… (Уходит.)' },
  {
    name: 'Пищик',
    phrase:
      ' Давненько не был у вас… прекраснейшая… (Лопахину.) Ты здесь… рад тебя видеть… громаднейшего ума человек… возьми… получи… (Подает Лопахину деньги.) Четыреста рублей… За мной остается восемьсот сорок.'
  },
  {
    name: 'Пищик',
    phrase:
      ' Постой… Жарко… Событие необычайнейшее. Приехали ко мне англичане и нашли в земле какую-то белую глину… (Любови Андреевне.) И вам четыреста… прекрасная, удивительная… (Подает деньги.) Остальные потом. (Пьет воду.) Сейчас один молодой человек рассказывал в вагоне, будто какой-то… великий философ советует прыгать с крыш… «Прыгай!», говорит, и в этом вся задача. (Удивленно.) Вы подумайте! Воды!..'
  },
  { name: 'Лопахин', phrase: ' Какие же это англичане?' },
  {
    name: 'Пищик',
    phrase:
      ' Сдал им участок с глиной на двадцать четыре года… А теперь, извините, некогда… надо скакать дальше… Поеду к Знойкову… к Кардамонову… Всем должен… (Пьет.) Желаю здравствовать… В четверг заеду…'
  },
  {
    name: 'Пищик',
    phrase:
      ' Как? (Встревоженно.) Почему в город? То-то я гляжу на мебель… чемоданы… Ну, ничего… (Сквозь слезы.) Ничего… Величайшего ума люди… эти англичане… Ничего… Будьте счастливы… Бог поможет вам… Ничего… Всему на этом свете бывает конец… (Целует руку Любови Андреевне.) А дойдет до вас слух, что мне конец пришел, вспомните вот эту самую… лошадь и скажите: «Был на свете такой, сякой… Симеонов-Пищик… царство ему небесное»… Замечательнейшая погода… Да… (Уходит в сильном смущении, но тотчас же возвращается и говорит в дверях.) Кланялась вам Дашенька! (Уходит.)'
  },
  { name: 'Аня', phrase: ' Мама, Фирса уже отправили в больницу. Яша отправил утром.' },
  {
    name: 'Лопахин',
    phrase:
      ' Я сам тоже не понимаю, признаться. Как-то странно все… Если есть еще время, то я хоть сейчас готов… Покончим сразу — и баста, а без вас я, чувствую, не сделаю предложения.'
  },
  {
    name: 'Лопахин',
    phrase: ' Кстати и шампанское есть. (Поглядев на стаканчики.) Пустые, кто-то уже выпил.'
  },
  { name: 'Лопахин', phrase: ' Что вы ищете?' },
  { name: 'Варя', phrase: ' Сама уложила и не помню.' },
  { name: 'Лопахин', phrase: ' Вы куда же теперь, Варвара Михайловна?' },
  {
    name: 'Варя',
    phrase: ' Я? К Рагулиным… Договорилась к ним смотреть за хозяйством… в экономки, что ли.'
  },
  { name: 'Лопахин', phrase: ' Это в Яшнево? Верст семьдесят будет.' },
  {
    name: 'Лопахин',
    phrase:
      ' А я в Харьков уезжаю сейчас… вот с этим поездом. Дела много. А тут во дворе оставляю Епиходова… Я его нанял.'
  },
  { name: 'Варя', phrase: ' Что ж!' },
  {
    name: 'Лопахин',
    phrase:
      ' В прошлом году об эту пору уже снег шел, если припомните, а теперь тихо, солнечно. Только что вот холодно… Градуса три мороза.'
  },
  { name: 'Варя', phrase: ' Я не поглядела.' },
  { name: 'Пауза', phrase: ' Голос в дверь со двора: «Ермолай Алексеич!..»' },
  {
    name: 'Гаев',
    phrase:
      ' Друзья мои, милые, дорогие друзья мои! Покидая этот дом навсегда, могу ли я умолчать, могу ли удержаться, чтобы не высказать на прощанье те чувства, которые наполняют теперь все мое существо…'
  },
  { name: 'Варя', phrase: ' Дядечка, не нужно!' },
  { name: 'Трофимов', phrase: ' Что же, господа, пора ехать!' },
  { name: 'Лопахин', phrase: ' Епиходов, мое пальто!' },
  {
    name: 'Гаев',
    phrase:
      ' Помню, когда мне было шесть лет, в Троицын день я сидел на этом окне и смотрел, как мой отец шел в церковь…'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Кажется, все. (Епиходову, надевая пальто.) Ты же, Епиходов, смотри, чтобы все было в порядке.'
  },
  { name: 'Лопахин', phrase: ' Что это у тебя голос такой?' },
  { name: 'Епиходов', phrase: ' Сейчас воду пил, что-то проглотил.' },
  { name: 'Лопахин', phrase: ' До самой весны.' },
  {
    name: 'Трофимов',
    phrase: ' Господа, идемте садиться в экипажи… Уже пора! Сейчас поезд придет!'
  },
  {
    name: 'Варя',
    phrase:
      ' Петя, вот они, ваши калоши, возле чемодана. (Со слезами.) И какие они у вас грязные, старые…'
  },
  {
    name: 'Лопахин',
    phrase:
      ' Все здесь? Никого там нет? (Запирает боковую дверь налево.) Здесь вещи сложены, надо запереть. Идем!..'
  },
  { name: 'Аня', phrase: ' Прощай, дом! Прощай, старая жизнь!' },
  { name: 'Трофимов', phrase: ' Здравствуй, новая жизнь!.. (Уходит с Аней.)' },
  { name: 'Лопахин', phrase: ' Значит, до весны. Выходите, господа… До свиданция!.. (Уходит.)' },
  { name: 'Гаев', phrase: ' Сестра моя, сестра моя!..' }
];
